import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { ProductProviderListModule } from './productproviderlist.module';
platformBrowserDynamic().bootstrapModule(ProductProviderListModule);
